(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/base.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/base.js');

'use strict';

class DialogBase {
  constructor(_ref) {
    let _ref$onConfirm = _ref.onConfirm,
      onConfirm = _ref$onConfirm === void 0 ? () => {} : _ref$onConfirm,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? () => {} : _ref$onCancel;
    this.onConfirm = onConfirm;
    this.onCancel = onCancel;
  }
  show() {
    svs.components.dialog.api.add(new svs.components.dialog.Confirm(this.createProps()));
  }
  createProps() {
    return {
      branding: svs.components.dialog.branding.TUR,
      type: this.getType(),
      icon: this.getIcon(),
      title: this.getTitle(),
      message: this.getMessage(),
      actions: this.getActions()
    };
  }
  getAccountOwner() {
    return 'Ditt';
  }

  getType() {
    return svs.components.dialog.type.INFO;
  }
  getIcon() {
    return 'games';
  }
  getTitle() {
    return '';
  }
  getMessage() {
    return [];
  }
  getActions() {
    return [];
  }
}
svs.tur.payment.dialogs.DialogBase = DialogBase;

 })(window);